import axios from 'axios';

axios.defaults.withCredentials = process.env.NODE_ENV === 'development';

const BASE_URL = process.env.NODE_ENV !== 'development' ? '//search.11st.co.kr' : '';

export default axios.create({
  baseURL: BASE_URL,
  headers: { 'content-type': 'application/x-www-form-urlencoded' },
  xsrfCookieName: '',
});
